import React, { useState } from 'react';
import classNames from 'classnames';
import { SvgIcon, Badge } from 'seduo-ui';
const Chip = ({ text, count, onClick, isSelected, className }) => {
    const [isActive, setIsActive] = useState(false);
    return (<Badge color="light" href="javascript:void(0);" className={classNames(`chip${isSelected ? ' chip-select' : ''}`, className)} onClick={onClick} onMouseEnter={() => setIsActive(true)} onFocus={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)} onBlur={() => setIsActive(false)}>
            <span className="text-nowrap d-flex align-items-center">
                <span className={`${isSelected ? 'mr-3' : ''}`} dangerouslySetInnerHTML={{
            __html: text,
        }}/>
                <span>
                    {isSelected ? (<SvgIcon kind={isActive ? 'CloseCircle' : 'CheckCircle'} className="icon" size={18}/>) : count > 0 ? (<span className="text-muted ml-2">({count})</span>) : null}
                </span>
            </span>
        </Badge>);
};
Chip.defaultProps = {
    isSelected: false,
    count: 0,
    className: '',
};
export default Chip;
